const getFormHelperTextProps = (InputProps?: { 'aria-errormessage'?: string }) => {
    return InputProps && InputProps['aria-errormessage']
        ? {
              id: InputProps['aria-errormessage'],
              'aria-live': 'assertive' as const,
          }
        : undefined;
};
export default getFormHelperTextProps;
